import type { Session } from "@supabase/supabase-js";
import type { Database } from "../types/database";

export const AUTHORIZED_SUPERUSER_EMAIL = "franca.cyan@gmail.com";
export const OWNER_ROLE_NAME = "owner";

type Profile = Database["public"]["Tables"]["profiles"]["Row"];
type Role = Pick<Database["public"]["Tables"]["roles"]["Row"], "code" | "name">;

export type AccessDecision =
  | { status: "unauthenticated"; reason: "missing-session" }
  | { status: "authorized"; email: string }
  | {
      status: "denied";
      reason:
        | "missing-email"
        | "unauthorized-email"
        | "missing-profile"
        | "profile-not-authorized"
        | "missing-owner-role";
      email: string | null;
    };

export function resolveAccess(
  session: Session | null,
  profile: Profile | null,
  roles: Role[],
): AccessDecision {
  const email = session?.user.email?.toLowerCase() ?? null;

  if (!session) {
    return { status: "unauthenticated", reason: "missing-session" };
  }

  if (!email) {
    return { status: "denied", reason: "missing-email", email };
  }

  if (email !== AUTHORIZED_SUPERUSER_EMAIL) {
    return { status: "denied", reason: "unauthorized-email", email };
  }

  if (!profile) {
    return { status: "denied", reason: "missing-profile", email };
  }

  if (!profile.is_authorized) {
    return { status: "denied", reason: "profile-not-authorized", email };
  }

  if (
    !roles.some(
      (role) =>
        role.code === OWNER_ROLE_NAME ||
        role.name.toLowerCase() === OWNER_ROLE_NAME,
    )
  ) {
    return { status: "denied", reason: "missing-owner-role", email };
  }

  return { status: "authorized", email };
}
